import { useNavigate, Link } from 'react-router-dom';
import * as C from './styles';
import { useForm, FormActions } from '../../../../FormContext';
import {Theme} from '../../theme';
import { ChangeEvent, useEffect, useState } from 'react';
import { submitOrcamento } from '../../../../data/Orcamento';
import { Alert } from 'react-bootstrap';

const SessionDate = () => {
    const navigate = useNavigate();
    const { state, dispatch } = useForm();
    const [show, setShow] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [sended, setSended] = useState(false);
    const [docId, setDocId] = useState('');

    useEffect(() => {
        if(state.name === '' || state.birth === '' || state.celphone === '' || state.description === '' || state.bodyPart === ''){
            navigate('/orcamento/ideia')            
        } else {
            dispatch({
                type: FormActions.setCurrentStep,
                payload: 4
            })
            const splited = state.name.split(" ");
            setFirstName(splited[0]);
        }
        return () => {
            
        };
    }, []);
    
    const handleDate = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch({
            type: FormActions.setDatePre,
            payload: e.target.value
        });
    }

    const handleHorario = (e: ChangeEvent<HTMLSelectElement>) => {
        dispatch({
            type: FormActions.setHourPre,
            payload: e.target.value
        })
    }

    const handleWhats = () => {
        let baseUrl = 'https://wa.me/5567999999278?text=';
        window.open(baseUrl+'Olá,%20acabei%20de%20solicitar%20um%20orçamento%21%0AId%3A%20'+docId, '_blank');
    }

    const handleSubmit = async () => {
        if(state.datePre !== '' && state.hourPre !== ''){
            let result = await submitOrcamento(state);
            if(result){
                setDocId(result.id)
            }
            setSended(true);
        } else {
            setShow(true);
        }        
    }

    if(!sended) return (
        <Theme>
            <C.Container>
                    <p className='ms-1'>{'Passo ' + state.currentStep + '/4'}</p>
                    <h1>Quando gostaria de fazer sua tattoo?</h1>
                    <p className='ms-1'>Informe o dia e periodo, caso não haja espaço na agenda na data desejada responderemos o orçamento informando a data mais próxima disponível.</p>
                    <hr/>
                    <div className="col-md-7 col-lg-4 mb-2">
                        <label htmlFor="data" className="mb-2 ms-4">
                            Data
                        </label>
                        <input 
                            id='data'
                            type='date' 
                            className='form-control' 
                            onChange={handleDate}
                            value={state.datePre}
                        />
                    </div>
                    <div className="col-md-3 col-lg-2 mb-2">
                        <label htmlFor="horario" className='mb-2 ms-4'>
                            Horario
                        </label>
                        <select className='form-select col-6' onChange={handleHorario}>
                            <option selected value=''>Selecione</option>
                            <option value='Manhã' selected={state.hourPre === 'Manhã'}>Manhã</option>
                            <option value='Tarde' selected={state.hourPre === 'Tarde'}>Tarde</option>
                            <option value='Noite' selected={state.hourPre === 'Noite'}>Noite</option>
                        </select>
                    </div>
                    <div className="col-md-4 col-lg-3 mb-2">
                    </div>
                    <div className="d-flex mt-4 justify-content-between align-items-center">
                        <Link to="/orcamento/ideia" className="back ms-1"><i className="bi bi-reply-fill"></i></Link>
                        <button className="btn btn-dark ms-1" onClick={handleSubmit}>Enviar <i className="bi bi-send ms-1"></i></button>
                    </div>
                {show &&
                    <div className="mt-4">
                        <Alert variant="warning" onClose={() => setShow(false)} dismissible className='p-2'>
                            Preencha os campos!
                        </Alert>
                    </div>
                }
            </C.Container>
        </Theme>
    ) 
    else {
        return (
            <C.Container>
                <div className='p-4 d-flex flex-column'>
                    <h1 className='mx-auto hconfirm mb-2'>Orçamento enviado!</h1>
                    <p className='confirm'>Agora é só aguardar, assim que possível enviarei a resposta com o valor via Whatsapp</p>
                    <hr/>
                    <p className='text-center'>Se preferir envie uma notificação no Whatsapp com o Id do seu orçamento, clicando no botão abaixo.</p>
                    <div className='d-flex'><button className='btn btn-dark mx-auto zap' onClick={handleWhats}><i className='bi bi-whatsapp'/></button></div>
                </div>
            </C.Container>
        )
    }
}

export default SessionDate;